import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import {
  AbstractValueAccessor,
  MakeProvider,
} from '../../abstracts/abstract-value-accessor';

@Component({
  selector: 'brn-input-highlight',
  templateUrl: './input-highlight.component.html',
  styleUrls: ['./input-highlight.component.scss'],
  providers: [MakeProvider(InputHighlightComponent)],
})
export class InputHighlightComponent extends AbstractValueAccessor {
  @Input() placeholder = 'Set value…';
  @ViewChild('inputField') inputField!: ElementRef;
  changed = false;

  handleInput(): void {
    if (!this.changed) {
      this.changed = true;
    }
  }

  escapeHtml(str: string): any {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  handleBlur(): void {
    if (this.changed) {
      // const rawValue = this.inputField.nativeElement.innerHTML;
      // const tmp = document.createElement('DIV');
      // tmp.innerHTML = rawValue;
      this.value =
        this.inputField.nativeElement.textContent ||
        this.inputField.nativeElement.innerText ||
        '';
      // this.value = this.inputField.nativeElement.innerHTML
      //   .replaceAll('<strong>{{', '{{')
      //   .replaceAll('}}</strong>', '}}');
      this.changed = false;
    }
  }
}
